import { render, staticRenderFns } from "./vipMallObject.vue?vue&type=template&id=161ccb04&scoped=true&"
import script from "./vipMallObject.vue?vue&type=script&lang=ts&"
export * from "./vipMallObject.vue?vue&type=script&lang=ts&"
import style0 from "./vipMallObject.vue?vue&type=style&index=0&id=161ccb04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ccb04",
  null
  
)

export default component.exports